/**
 * Mock data for the DataVisualization component
 * Represents political parties and their project counts
 */

// Mock data for parties and their project counts
export const partyProjectsData = [
  { party: 'PSOL', projects: 42, temperature: 37 },
  { party: 'PT', projects: 78, temperature: 38 },
  { party: 'REDE', projects: 35, temperature: 37 },
  { party: 'PCdoB', projects: 56, temperature: 38 },
  { party: 'PSB', projects: 63, temperature: 38 },
  { party: 'PDT', projects: 49, temperature: 37 },
  { party: 'PV', projects: 28, temperature: 37 },
  { party: 'CID', projects: 31, temperature: 37 },
  { party: 'SD', projects: 45, temperature: 37 },
  { party: 'PODE', projects: 52, temperature: 38 },
  { party: 'AVAN', projects: 39, temperature: 37 },
  { party: 'PSDB', projects: 67, temperature: 38 },
  { party: 'PSD', projects: 83, temperature: 39 },
  { party: 'PROS', projects: 41, temperature: 37 },
  { party: 'PATRI', projects: 37, temperature: 37 },
  { party: 'S.P.', projects: 29, temperature: 37 },
  { party: 'UNIÃO', projects: 91, temperature: 39 },
  { party: 'REP', projects: 58, temperature: 38 },
  { party: 'PSC', projects: 47, temperature: 37 },
  { party: 'MDB', projects: 105, temperature: 40 },
  { party: 'PP', projects: 112, temperature: 40 },
  { party: 'PL', projects: 127, temperature: 41 },
  { party: 'PTB', projects: 72, temperature: 38 },
  { party: 'NOVO', projects: 138, temperature: 42 }
];

// Helper function to get temperature based on project count
export const getTemperature = (projectCount) => {
  if (projectCount < 40) return 37;
  if (projectCount < 60) return 38;
  if (projectCount < 90) return 39;
  if (projectCount < 120) return 40;
  if (projectCount < 130) return 41;
  return 42;
};

// Helper function to get color based on temperature
export const getTemperatureColor = (temperature) => {
  const colors = {
    37: '#2c3e50', // Very Dark Blue (coolest)
    38: '#2980b9', // Dark Blue
    39: '#3498db', // Blue
    40: '#8e44ad', // Purple
    41: '#d35400', // Dark Orange
    42: '#e74c3c'  // Red (hottest)
  };
  return colors[temperature] || colors[37];
};

// Get all parties sorted by project count (descending)
export const getPartiesByProjectCount = () => {
  return [...partyProjectsData].sort((a, b) => b.projects - a.projects);
};

// Get top N parties by project count
export const getTopParties = (count = 5) => {
  return getPartiesByProjectCount().slice(0, count);
};
